import { useContext, useState } from "react";
import {
    TransactionView,
    TransactionViewSchema,
} from "@common/types/views/transactionViews";
import { PaginatedTransactionsDataContext } from "@components/transactions/PaginatedTransactionsTable.context";
import { PaginatedTransactionsTableContextProvider } from "@components/transactions/PaginatedTransactionsTableContextProvider";
import { TransactionsBulkActionsContextProvider } from "@components/transactions/TransactionsBulkActions/TransactionsBulkActionsContextProvider";
import { TransactionsView } from "@components/transactions/views/TransactionsView";
import {
    TemplateTaskDataTable,
    TemplateTaskTableProps,
} from "./TemplateTaskDataTable";
import { ResolvedTaskView } from "./useResolvedTaskView";

interface Props {
    /** The template's own view: its columns and options are what the table shows. */
    templateView: TransactionView;
    onTemplateViewChange: (view: TransactionView) => void;
    resolvedView: ResolvedTaskView;
    workspaceId: string | null;
}

const ReadOnlyTable = ({
    view,
    onViewChange,
    emptyView,
}: TemplateTaskTableProps<TransactionView>) => {
    const { transactionCount } = useContext(PaginatedTransactionsDataContext);

    return (
        <TransactionsBulkActionsContextProvider
            currentFilters={view.filters}
            totalTransactions={transactionCount}
            onUpdated={() => {}}
        >
            <TransactionsView
                view={view}
                emptyView={emptyView}
                onViewChange={onViewChange}
                fixedTopOffsetPx
            />
        </TransactionsBulkActionsContextProvider>
    );
};

const ResolvedTable = (props: TemplateTaskTableProps<TransactionView>) => {
    const [page, setPage] = useState(1);

    return (
        <PaginatedTransactionsTableContextProvider
            defaultView={props.view}
            paginationMode={{ type: "pages", page, setPage }}
            disableSimilarTransactionsUpdate
        >
            <ReadOnlyTable {...props} />
        </PaginatedTransactionsTableContextProvider>
    );
};

const renderTransactionsTable = (
    props: TemplateTaskTableProps<TransactionView>,
) => <ResolvedTable {...props} />;

/**
 * The rows a transactions template task would show for the previewed client.
 * Read-only: no selection, bulk actions or row details.
 */
export const TemplateTransactionsDataTable = (props: Props) => (
    <TemplateTaskDataTable
        {...props}
        viewSchema={TransactionViewSchema}
        rowsLabel="transactions"
        renderTable={renderTransactionsTable}
    />
);
